import { Component, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ThemeService } from '../../services/theme.service';
import { UserService } from '../../services/user.service';
import { User } from '../../interfaces/user.interface';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AuthButtonsComponent } from '../auth-buttons/auth-buttons.component';
import { ToggleThemeComponent } from '../toggle-theme/toggle-theme.component';
import { NavItemsComponent } from '../nav-items/nav-items.component';
import { BalanceBlockComponent } from '../balance-block/balance-block.component';
import { LogoComponent } from '../logo/logo.component';
import { NgClass, NgIf, AsyncPipe, NgFor, UpperCasePipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Environment } from '../../interfaces/environment.interface';
import { Apps } from '../../interfaces/apps.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'wm-libs-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    MatToolbarModule,
    NgClass,
    NgFor,
    UpperCasePipe,
    TranslateModule,
    LogoComponent,
    NgIf,
    BalanceBlockComponent,
    NavItemsComponent,
    ToggleThemeComponent,
    AuthButtonsComponent,
    MatButtonModule,
    MatIconModule,
    AsyncPipe,
  ],
})
export class HeaderComponent implements OnDestroy {
  @Input() app!: Apps;
  @Input() env!: Environment;
  @Input() balance!: number | null;
  @Input() accessToken = false;
  @Input() accessTokenPermissions?: string[];
  @Output() menuToggle = new EventEmitter<void>();

  private authSubscription!: Subscription;
  private userDataSubscription!: Subscription;

  isDarkMode$: Observable<boolean>;

  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  isAuth = false;

  userData!: User | null;

  constructor(private breakpointObserver: BreakpointObserver, private themeService: ThemeService, private userService: UserService) {
    this.isDarkMode$ = this.themeService.isDarkMode$;

    this.authSubscription = this.userService.isAuthenticated$.subscribe((status) => {
      this.isAuth = status;
    });

    this.userDataSubscription = this.userService.userData$.subscribe((user) => {
      this.userData = user;
    });
  }

  toggleMenu() {
    this.menuToggle.emit();
  }

  toggleDarkMode() {
    this.themeService.toggleDarkMode();
  }

  ngOnDestroy() {
    if (this.authSubscription) this.authSubscription.unsubscribe();
    if (this.userDataSubscription) this.userDataSubscription.unsubscribe();
  }
}
